import React from "react";
import { FiArrowUpRight } from "react-icons/fi";
function NavArrow() {
  return (
    <>
      <FiArrowUpRight className="navarrow inline" size={14} />
    </>
  );
}

export default NavArrow;
